// src/store/thunks/administrators/fetchAdminInfoThunk.ts
import { createAdminAsyncThunk } from '@/store/thunks/createAdminAsyncThunk';
import type { AdminInfoResponse } from '@/types/administrators.types';
import { isAPIError } from '@/store/utils';
import { EMPTY_FIELD_ERRORS, type RejectValue } from '@/types/thunk.types';

export const fetchAdminInfoThunk = createAdminAsyncThunk<
  AdminInfoResponse,
  { id: string },
  { rejectValue: RejectValue }
>(
  'administrators/fetchAdminInfo',
  async({ id }, { extra: { administratorsService }, rejectWithValue }) => {
    try {
      const result = await administratorsService.adminInfo(id);
      return result;
    } catch (err: unknown) {
      if (isAPIError(err) && err.fieldErrors !== null) {
        return rejectWithValue({ fieldErrors: EMPTY_FIELD_ERRORS });
      }
      const message =
        err instanceof Error ? err.message : 'Failed to fetch administrator info';
      return rejectWithValue({ message });
    }
  }
);
